import { c as _c } from "react/compiler-runtime";
import { CardList } from '../card-list/card-list.tsx';
import { SacCardSkeleton } from '../sac-card/sac-card.tsx';
type SacListSkeletonProps = {
  itemCount?: number;
  columns?: number;
  columnsSm?: number;
  columnsMd?: number;
  columnsLg?: number;
};
export const SacListSkeleton: React.FC<SacListSkeletonProps> = t0 => {
  const $ = _c(8);
  const {
    itemCount: t1,
    columns: t2,
    columnsSm: t3,
    columnsMd: t4,
    columnsLg: t5
  } = t0;
  const itemCount = t1 === undefined ? 12 : t1;
  const columns = t2 === undefined ? 1 : t2;
  const columnsSm = t3 === undefined ? 2 : t3;
  const columnsMd = t4 === undefined ? 2 : t4;
  const columnsLg = t5 === undefined ? 3 : t5;
  let t6;
  if ($[0] !== itemCount) {
    t6 = Array.from({
      length: itemCount
    }, _temp);
    $[0] = itemCount;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== columns || $[3] !== columnsLg || $[4] !== columnsMd || $[5] !== columnsSm || $[6] !== t6) {
    t7 = <CardList columns={columns} columnsSm={columnsSm} columnsMd={columnsMd} columnsLg={columnsLg} classNameGap="gap-y-roomy-xs gap-x-comfy-xl">{t6}</CardList>;
    $[2] = columns;
    $[3] = columnsLg;
    $[4] = columnsMd;
    $[5] = columnsSm;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
function _temp(_, index) {
  return <SacCardSkeleton key={index} />;
}